import SEOHead from '@/components/feature/SEOHead';
import Header from '@/pages/home/components/Header';
import Footer from '@/pages/home/components/Footer';
import RenovationHero from './components/RenovationHero';
import RenovationServices from './components/RenovationServices';
import RenovationReferences from './components/RenovationReferences';
import RenovationProcess from './components/RenovationProcess';
import RenovationCTA from './components/RenovationCTA';

export default function Renovation() {
  return (
    <>
      <SEOHead
        title="Travaux de Rénovation Neuenegg | CasaReNovaPlus - Tous Types de Rénovation Suisse"
        description="CasaReNovaPlus à Neuenegg : tous types de travaux de rénovation intérieure et extérieure. Cuisine, salle de bain, peinture, parquet, menuiserie. Devis gratuit."
        keywords="rénovation Neuenegg, travaux rénovation Fribourg, CasaReNovaPlus, rénovation maison Suisse, rénovation cuisine salle de bain"
        canonical="https://casarenovaplus.ch/renovation"
      />
      <Header />
      <main>
        <RenovationHero />
        <RenovationServices />
        <RenovationProcess />
        <RenovationReferences />
        <RenovationCTA />
      </main>
      <Footer />
    </>
  );
}
